import { render, staticRenderFns } from "./EditFareGroupDialog.vue?vue&type=template&id=26be0610&"
import script from "./EditFareGroupDialog.vue?vue&type=script&lang=js&"
export * from "./EditFareGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports